import type { HRContractStatus } from '@/api/client'
import { cn } from '@/lib/cn'
import { useTranslation } from 'react-i18next'

interface Props {
  status: HRContractStatus
  className?: string
}

export function ContractStatusBadge({ status, className }: Props) {
  const { t } = useTranslation('hr')
  const styles: Record<HRContractStatus, string> = {
    draft: 'bg-muted text-muted-foreground',
    active: 'bg-primary text-primary-foreground',
    suspended: 'bg-muted text-foreground',
    expired: 'bg-muted text-muted-foreground',
    terminated: 'bg-muted text-muted-foreground line-through',
  }
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
        styles[status],
        className,
      )}
    >
      {t(`contract_status.${status}`, { defaultValue: status })}
    </span>
  )
}
